<template>
	<el-drawer title="添加物料" :visible.sync="visible" @close='comStateClose' size="56%" :close-on-press-escape="false"
		id="comDrawer">
		<div class="drawerView">
			<div class="drawerViewT">
				<div class="drawerSearch">
					<div class="drawerRow" v-for="(item,index) in treeData" :key="index">
						<div class="drawerName">{{item.label}}:</div>
						<div class="drawerRowR">
							<div :class="[childItem.id==selectId?'activeDrawerCol':'drawerCol']"
								v-for="(childItem,childIndex) in item.children" :key="childIndex"
								@click="handleTabClick(childItem)">{{childItem.label}}</div>
						</div>
					</div>
				</div>
				
				<div class="drawerInput">
					<el-input v-model="keyword" placeholder="请输入内容" size="small" prefix-icon="el-icon-search" style="width: 200px"></el-input>
					<el-button size="small" style="margin: 0 10px;">搜索</el-button>
					<el-button size="small" type="warning" @click="handleResetClick">重置</el-button>
				</div>
				
				<el-table :data="tableData" style="width: 100%">
					<el-table-column prop="name" label="名称">
					</el-table-column>
					<el-table-column prop="brand" label="品牌">
					</el-table-column>
					<el-table-column prop="unit" label="单位">
					</el-table-column>
					<el-table-column prop="categoryInfo.name" label="分类">
					</el-table-column>
					<el-table-column label="操作" width="60">
						<template slot-scope="scope">
							<el-button @click="handleSelectClick(scope.row)" type="text" size="small">选择</el-button>
						</template>
					</el-table-column>
				</el-table>
				
				<!-- 分页 -->
				<page :page="page.page" :total="page.total" @change="changePage" :paseSize="page.pageSize" style="margin: 10px 0;"></page>
			</div>
		</div>

	</el-drawer>
</template>

<script>
	import page from "../../../../components/page.vue"
	export default {
		components: {
			page
		},
		props: {
			comState: { //显示状态
				default: false
			},
		},
		data() {
			return {
				page: {
					page: 1,
					pageSize: 10,
					total: 0
				},
				visible: true,
				treeData: [], //获取树形数据
				selectId: '', //选中id
				tableData:[],  //表格
				keyword:'',
			}
		},
		mounted() {
			this.getTreeData()
			this.getTableData()
		},
		methods: {
			//选择
			handleSelectClick(row){
				console.log(row)
				let obj = {
					brand:row.brand,
					categoryInfo:row.categoryInfo,
					cover:row.cover,
					name:row.name,
					remark:'',
					id:row.id,
					num:1,
					unit:row.unit
				}
				this.$emit("submit",obj)
			},
			//重置
			handleResetClick(){
				this.selectId = '';
				this.keyword = '';
				this.getTableData()
			},
			// 分页方法
			changePage(num) {
				this.page.page = num;
				this.getTableData();
			},
			//表格
			getTableData() {
				let params ={
					pageIndex:this.page.page,
					pageSize:this.page.pageSize,
					categoryId:this.selectId,
					keyword:this.keyword,
					shopId:this.$store.getters.curShopInfo.shop_id,
				}
				// console.log(params)
				this.$http.post(process.env.VUE_APP_Url_8022 + '/api/Material/Shop/info/List',params).then(
					res => {
						if (res.code == 0) {
							// console.log('物料列表',res.data)
							this.tableData = res.data.list;
							this.page.total = res.data.count;
						}
					})
			},
			//选择类型
			handleTabClick(item) {
				this.selectId = item.id;
				this.getTableData()
			},
			//获取树形数据
			getTreeData() {
				this.$http.get(process.env.VUE_APP_Url_baseData + '/api/Material/category/tree').then(
					res => {
						if (res.code == 0) {
							// console.log('树形数据', res)
							this.treeData = res.data
						}
					})
			},
			//向父组件发射关闭弹框
			comStateClose() {
				this.$emit("closeOn", false);
			},
		},
		watch: {
			// 监视状态发生改变
			comState() {
				this.visible = this.comState;
			},
		},
	}
</script>

<style scoped lang="scss">
	#comDrawer {
		::v-deep .el-drawer__header {
			padding: 20px;
			margin-bottom: 0;
		}

		::v-deep .el-drawer__body {
			height: calc(100% - 65px);
			overflow-y: auto;
		}
	}

	.drawerView {
		height: 100%;

		.drawerViewT {
			height: calc(100% - 60px);
			box-sizing: border-box;
			border-top: solid 1px #F2F2F2;
			overflow-y: scroll;

			.drawerSearch {
				padding: 0 20px;

				.drawerRow {
					font-size: 14px;
					padding: 20px 0 10px 0;
					display: flex;
					box-sizing: border-box;
					border-bottom: solid 1px #F4F4F4;

					.drawerName {
						width: 100px;
						text-align: right;
						font-weight: bold;
						margin-right: 12px;
					}

					.drawerRowR {
						flex: 1;
						display: flex;
						flex-wrap: wrap;
					}

					.drawerCol {
						color: #666;
						margin-right: 40px;
						margin-bottom: 10px;
					}

					.activeDrawerCol {
						color: #F77E04;
						margin-right: 40px;
						margin-bottom: 10px;
					}
				}
			}
			
			.drawerInput{
				display: flex;
				padding: 10px 20px;
			}

		}

		.drawerViewT::-webkit-scrollbar {
			display: none;
		}

		.drawerViewB {
			height: 60px;
			display: flex;
			justify-content: flex-end;
			align-items: center;
			padding: 0 20px;
			border-top: solid 1px #F2F2F2;
			box-sizing: border-box;

			.btn {
				width: 98px;
				line-height: 40px;
				text-align: center;
				background: #F58B2F;
				border-radius: 10px;
				font-size: 16px;
				font-weight: bold;
				color: #fff;
				cursor: pointer;
				margin-left: 20px;
			}

			.btn2 {
				width: 98px;
				line-height: 40px;
				text-align: center;
				background: #E3E3E3;
				border-radius: 10px;
				font-size: 16px;
				font-weight: bold;
				color: #666;
				cursor: pointer;
			}
		}
	}
</style>
